
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<input id=\"{{ id }}\" type=\"checkbox\" class=\"input-password-toggle\" aria-controls=\"{{ targetId }}\" tabindex=\"-1\" data-novalue data-synchronize-show=\"{{ synchronizeShow }}\"/>\n<label for=\"{{ id }}\" class=\"input-password-toggle-label-show\" title=\"{{#t}}Show password{{/t}}\" aria-label=\"{{#t}}Show password{{/t}}\">\n</label>\n"
      return mustache.render(src, view, partials);
    };
  